import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postLendsRemitURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Select,
    Progress
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
import useGetMechanics from "../hooks/useGetMechanics";


function RemitLend({
    isOpen,
    onClose,
    successCallback, 
    lendData, 
}) {

    const [ remarks, setRemarks ] = useState('');

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);


    const postLends = async (e) => {
        e.preventDefault();

        setSubmitting(true);
        // console.log(cover);

        let id = lendData ? lendData.id : undefined

        // console.log(description, password);
        axios.post(postLendsRemitURL(id), {
            remarks: remarks ? remarks : '',
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setErrors([]);
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            // console.log(e.response);
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    if (!isOpen || !lendData) {
        return (<></>);
    }


    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Return Lended {lendData.tool.name}?</ModalHeader>
                <ModalCloseButton />
                <ModalBody>


                    <Flex align="center"
                        mb="10px">
                        <Text
                        fontSize="md"
                        fontWeight="bold"
                        >
                        Borrower:{" "}
                        </Text>
                        <Text fontSize="md" color="gray.500" fontWeight="400">
                            {lendData.mechanic.firstName} {lendData.mechanic.lastName}
                        </Text>
                    </Flex>
                    <Flex align="center"
                        mb="10px">
                        <Text
                        fontSize="md"
                        fontWeight="bold"
                        >
                        Quantity:{" "}
                        </Text>
                        <Text fontSize="md" color="gray.500" fontWeight="400">
                            {lendData.quantity}
                        </Text>
                    </Flex>

                    <Box pr="12px">
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Remarks
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Set Remarks"
                            size="md" 
                            value={remarks} 
                            onChange={e => setRemarks(e.target.value)}
                        />
                    </Box>

                    <form onSubmit={postLends}>

                        <FormControl >

                            <Flex w="100%" flexDir="column">
                                { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                            </Flex>
                            <Button
                                fontSize="10px"
                                type="submit"
                                bg="teal.300"
                                w="100%"
                                h="45"
                                mb="20px"
                                color="white"
                                mt="0px"
                                _hover={{
                                bg: "teal.200",
                                }}
                                _active={{
                                bg: "teal.400",
                                }}
                                isDisabled={submitting}
                            >
                                CONFIRM AND SUBMIT
                            </Button>
                        </FormControl>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default RemitLend;
